const checkFieldDisabledStatus = ({
  fieldAccesses,
  fieldName,
  currentState,
  skipStateCanEditThisFieldCheck,
  disabledFromParent,
  processualDisabledFromParent,
  entityIsProcessual,
  pageIsProcessual,
  isMongoField,
  mongoRuleField = "updatablePathFieldsInMongoDb",
  hasSQLEntity = true,
  mongoFieldPath,
  // checkProcessualEditablity,
  // checkProcessualExceptions,
}) => {
  let disabled = true;
  let processualDisabled = false;
  const hasNoDirectFieldAccess = isMongoField && !hasSQLEntity;
  // debugger toast for when we have forgotten to pass the needed attributes to the function
  if (
    !skipStateCanEditThisFieldCheck &&
    !currentState &&
    entityIsProcessual &&
    currentState === undefined
  ) {
    console.warn("Debug: currentState not found, check usage, call PNG!");
  }

  // extracting needed part of field config
  const entityName = hasNoDirectFieldAccess ? null : fieldName?.split("_")[0]; //"mongoDocumentManipulationRules";
  const entityFieldConfig = fieldAccesses?.[entityName];
  const fieldAccessObj = hasNoDirectFieldAccess
    ? null // entityFieldConfig?.[mongoRuleField] || ""
    : entityFieldConfig && Array.isArray(entityFieldConfig)
      ? entityFieldConfig?.find((acc) => acc?.fieldName === fieldName)
      : null;

  if (fieldAccessObj || hasNoDirectFieldAccess) {
    // disabled WORKS
    disabled = disabledFromParent
      ? true
      : hasNoDirectFieldAccess
        ? false
        : fieldAccessObj?.manipulationAccess === true
          ? false
          : true;

    // processualDisabled WORKS
    if (pageIsProcessual) {
      // 👆 Check to see if we need to do processualDisabled calcs or not (it is different in different ***PAGES***)
      if (!disabled) {
        // 👆 Check to see if we need to do processualDisabled calcs or not (disabled is above processualDisabled)

        if (isMongoField) {
          if (skipStateCanEditThisFieldCheck) {
            processualDisabled = false;
          } else {
            const mongoDocumentManipulationRules = fieldAccesses?.mongoDocumentManipulationRules;
            const mongoDocumentManipulationRuleTarget = mongoDocumentManipulationRules?.[mongoRuleField];
            processualDisabled = !mongoDocumentManipulationRuleTarget
              ?.split(",")
              ?.includes(
                mongoFieldPath ? mongoFieldPath : hasSQLEntity ? fieldName?.split("_")[1] : fieldName,
              );
          }
        } else {
          if (processualDisabledFromParent) {
            // 👆 Processual page ,  Condition : check to see if our parent exists and it is disable

            if (fieldAccessObj?.processualUpdatableException === true) {
              // 👆 Processual page && parent exists && it is disable , Condition : reached an exception based on processualUpdatableException

              processualDisabled = false;
            } else {
              // 👆 Processual page && parent exists && it is disable , Condition : did not reached an exception based on processualUpdatableException

              processualDisabled = true;
            }
          } else {
            // 👆 Processual page ,  Condition : check to see if our parent does not exist || processualDisabledFromParent is false

            if (entityIsProcessual) {
              // 👆 Processual page && parent does not exist (means we are in the first level of a processual entity)

              if (skipStateCanEditThisFieldCheck) {
                // 👆 Processual page && parent does not exist (means we are in the first level of a processual entity) && client is inserting so we must not prevent

                processualDisabled = false;
              } else {
                // 👆 Processual page && parent does not exist (means we are in the first level of a processual entity) && !inserting , Condition : we check statesCanEditThisField for pur processual field

                processualDisabled = fieldAccessObj?.statesCanEditThisField
                  ?.split("-")
                  ?.filter((which) => which !== "")
                  ?.includes(currentState)
                  ? false
                  : true;
              }
            } else {
              // 👆 Processual page && parent exists but processualDisabledFromParent is false (parent has given the access to edit)

              processualDisabled = false;
            }
          }
        }
      }
    }
  }
  return {
    disabled,
    processualDisabled,
  };
};

export default checkFieldDisabledStatus;
